import { get } from 'lodash'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { braintree, common, error, formData, payment, stripe } from '../../../../constants/actions'
import withColorSetting from '../../../../hoc/withColorSettings'
import {
  getBraintreeId,
  getBTPaymentMethods,
  getFormSettings,
  getFormType,
  getIsGuestSignup,
  getOrderId,
  getPaymentGateways,
  getUser,
} from '../../../../selectors'
import PaymentComponent from './component'

const mapStateToProps = state => ({
  paymentData: get(state, 'payment.paymentData'),
  isPaymentSuccessful: get(state, 'auth.paymentSuccessful'),
  user: get(state, 'auth.user'),
  organisation: get(state, 'formInfo.organisation'),
  sessions: get(state, 'formData.sessions'),
  paymentPageError: get(state, 'error.paymentPageError'),
  braintreeToken: get(state, 'payment.braintreeToken'),
  paymentMethod: get(state, 'payment.paymentMethod'),
  braintreeId: getBraintreeId(state),
  paymentGateway: getPaymentGateways(state),
  braintreePaymentMethods: getBTPaymentMethods(state),
  isGuestSignup: getIsGuestSignup(state),
  formType: getFormType(state),
  formSettings: getFormSettings(state),
  userData: getUser(state),
  orderId: getOrderId(state),
  stripeData: get(state, 'stripe'),
})

export default withRouter(
  connect(mapStateToProps, {
    clearRegistrations: payment.clearRegistrations,
    postFormData: payment.postFormData,
    submitPayment: payment.submitPayment,
    paymentSuccessful: payment.paymentSuccessful,
    validateSessions: formData.validateSessions,
    setPaymentPageError: error.onPaymentPageError,
    getBraintreeToken: payment.getBraintreePaymentToken,
    postPayment: payment.submitPostPayment,
    showLoadingIndicator: common.setShowLoadingIndicator,
    setLoadingIndicatorContent: common.setLoadingIndicatorContent,
    setPaymentMethod: payment.setPaymentMethod,
    getBTPaymentMethods: braintree.getBTPaymentMethods,
    deleteBTPaymentMethod: braintree.deleteBTPaymentMethod,
    createStripePaymentIntent: stripe.createPaymentIntent,
  })(withColorSetting(PaymentComponent))
)
